import { createFileRoute } from "@tanstack/react-router";
import ProfileAppearance from "@/features-common/profile-appearance-form";

export const Route = createFileRoute("/_root/root-user/settings/appearance")({
  component: ProfileAppearance,
});
